import React, { useEffect, useState } from 'react';
import UniversalMediaElement from '../widgets/js/UniversalMediaElement'
import axios from 'axios';

function Menu() {
  const [videos_for_home_page, setVideosForHomePage] = useState([]); // Estado para almacenar las imagenes del carrousel
  const apiDomain = process.env.REACT_APP_DOMAIN_API;
  const withSSL = process.env.REACT_APP_SSL;

  const get_list_objects = async() => {

    await axios.get(`http${withSSL}://${apiDomain}/api/no_auth/media_content_home_page/16/`).then(
      response => {
        const videos = response.data[0].videos.map(video => video.video);
        var order_videos = [];

        for(var i0 = 0; i0 < videos.length; i0++){
          if(videos[i0].includes(".mp4")){
            order_videos[0] = videos[i0];
          }

          if(videos[i0].includes(".webm")){
            order_videos[1] = videos[i0];
          }

          if(videos[i0].includes(".mov")){
            order_videos[2] = videos[i0];
          }
          
        }

        setVideosForHomePage(order_videos)
      }
    ).catch(
      error => console.log(error)
    )

  }

  useEffect(() => {
    get_list_objects();
  }, []);

  return (
    <>
      <UniversalMediaElement option_to_video_or_image={0} title_info_page={"EXPLORA NUESTRO SABOR ÚNICO"} title_info_page_description={"Experiencia Gastronómica Excepcional"} title_info_page_button={""} option_to_navigate_button_media={"/food_menu"} videos_for_home_page={videos_for_home_page}/>
    </>
  )
}

export default Menu